import React, { Component } from "react";

import { Navigate } from "react-router-dom";
import AuthField from "../AuthField/AuthField";
import AuthWindow from "../AuthWindow/AuthWindow";
import { Alert } from "../../Component/Alert";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import "../Passport.css";

type FinishSocialSignupProps = {
    followRedirects: boolean;
    tokenIsSet: boolean;
    status: string;
    usernameError: string;
    statusMessage: string;
    handleSubmit: Function;
};

class FinishSocialSignup extends Component<FinishSocialSignupProps, any> {
    usernameRef: React.RefObject<HTMLInputElement>;

    constructor(props: any) {
        super(props);

        this.state = {
            usernameError: props.usernameError,
            statusMessage: props.statusMessage
        };

        this.usernameRef = React.createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    static getDerivedStateFromProps(props: any, state: any) {
        state.usernameError = props.usernameError;
        state.statusMessage = props.statusMessage;
        return state;
    }

    handleSubmit(ev: React.FormEvent<HTMLFormElement>) {
        ev.preventDefault();

        var username = this.usernameRef.current!.value;
        var errors: boolean = false;

        if (username.length < 3) {
            this.setState({
                usernameError: "Username is not long enough"
            });
            errors = true;
        }

        if (!errors) this.props.handleSubmit(username);
    }

    render() {
        var statusMessage = this.state.statusMessage;

        if (!this.props.tokenIsSet) {
            if (this.props.followRedirects !== false) {
                console.log("Redirecting because Token is not set");
                statusMessage = "Redirecting to profile page.";
                return <Navigate to="/" />;
            }
        }

        return (
            <AuthWindow
                image="/images/adult-art-character-1333304.jpg"
                source_url="https://www.pexels.com/photo/red-and-multicolored-figure-1333320/?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels"
                author="Magda Ehlers"
                author_url="https://www.pexels.com/@magda-ehlers-pexels?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels"
            >
                <Grid container justifyContent="center">
                    <Grid container item xs={12} sm={12} md={4}>
                        <Card>
                            <div className="form-half">
                                <h2>
                                    <span className="fa fa-sign-in"></span>{" "}
                                    Finish Signup
                                </h2>
                                <p className="text-muted">
                                    Please enter a unique username to complete
                                    your registration.
                                </p>
                                <form
                                    id="finishSocialSignupForm"
                                    onSubmit={this.handleSubmit}
                                    method="POST"
                                >
                                    <Grid container spacing={2}>
                                        <Grid container item xs={12}>
                                            <AuthField
                                                label="Username"
                                                error={this.state.usernameError}
                                                reference="username"
                                                ref={this.usernameRef}
                                            />
                                        </Grid>{" "}
                                        <Grid container item xs={12}>
                                            <Button
                                                type="submit"
                                                id="submitFinishSocialSignupForm"
                                                color="primary"
                                                variant="contained"
                                            >
                                                Complete Signup
                                            </Button>
                                        </Grid>
                                        <Grid container item xs={12}>
                                            <Alert
                                                status={this.props.status}
                                                message={statusMessage}
                                            />
                                        </Grid>
                                    </Grid>
                                </form>
                                <hr />
                                <br />
                            </div>
                        </Card>
                    </Grid>
                </Grid>
            </AuthWindow>
        );
    }
}

export default FinishSocialSignup;
